//Authentication service
import axios from "axios";
import { BASE_URL } from "../BaseUrl";
import authHeader from "./auth-header";

const API_URL = BASE_URL;

// const register = (username, email, password) => {
//   return axios.post(API_URL + "signup", {
//     username,
//     email,
//     password,
//   });
// };

const login = async (uname, password) => {
  const response = await axios.post(
    API_URL + "login",
    {
      uname,
      password,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  if (response.data.accessToken) {
    localStorage.setItem("user", JSON.stringify(response.data));
  }
  console.log(response.status)
  return response.data;
};

const logout = () => {
  localStorage.removeItem("user");
};

const verifyOtp = async (uname, password, otp) => {
  const otp_n=parseInt(otp);
  const response = await axios.post(
    API_URL + "webverifyotp",
    {
      uname,
      password,
      otp:otp_n,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  if (response.data.accessToken) {
    localStorage.setItem("user", JSON.stringify(response.data));
  }
  return response.data;
};

const resendOtp = async (uname, password) => {
  const response = await axios.post(
    API_URL + "webresendotp",
    {
      uname,
      password,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

const authService = {
  // register,
  login,
  logout,
  verifyOtp,
  resendOtp,
};

export default authService;
